import { StrictMode } from 'react';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import './index.css';

import { createRouter, RouterProvider } from '@tanstack/react-router';

import Providers from './components/providers';
import { routeTree } from './routeTree.gen';

import './lib/i18n';

import { queryClient } from './lib/query-client';

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

Sentry.init({
  release: import.meta.env.VITE_APP_VERSION,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.MODE === 'production',
  dsn: 'https://98abb9348c4e590750123d7644de01ef@o4507828530118656.ingest.de.sentry.io/4509038846541904',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.tanstackRouterBrowserTracingIntegration(router),
  ],
  beforeSend(event) {
    if (window.location.pathname === '/login') return null;
    return event;
  },

  // Tracing
  tracesSampleRate: 0.3, //  Capture 50% of the transactions
  tracePropagationTargets: ['localhost', /^https:\/\/esmg\.gr\/api/],
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// eslint-disable-next-line react-refresh/only-export-components
const TanStackRouteProvider = () => {
  return <RouterProvider router={router} />;
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers>
      <TanStackRouteProvider />
    </Providers>
  </StrictMode>
);
